var map = {
	"./IMG_3876 2.JPG": 810,
	"./IMG_3877.JPG": 485,
	"./IMG_8137.PNG": 337,
	"./IMG_8156.PNG": 542,
	"./IMG_8157.PNG": 335,
	"./IMG_8158.PNG": 600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198;